import React, { LegacyRef, useEffect, useMemo, useRef, useState } from "react"
import { autorun, computed, reaction } from "mobx"
import { observer } from "mobx-react"
import { Button, Flex, Modal } from "antd"

import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import { calcPlacement } from "@src/widgets/onboarding/constants"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { OnboardingStepComponentWrap } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

type Props = {
  actions: {
    next: () => Promise<void>
    prev: () => Promise<void>
  }
  tour: BaseTour
}
export const OnboardingTourModal = observer(({ actions, tour }: Props) => {
  const [offsets, setOff] = useState<ReturnType<typeof calcPlacement>>(null)
  const step = computed<TourStepBase>(() => {
    return tour.activeStep as TourStepBase
  }).get()

  const ref = useRef<HTMLElement>()

  const backIsShown = computed(() => {
    return !(tour.name === ONBOARDING_TOURS.WELCOME && tour.isInitialStep)
  }).get()

  const placementCoords = useMemo(() => {
    if (step.settings.placement === undefined || !offsets) {
      return {}
    }

    return offsets[step.settings.placement]
  }, [offsets, step.settings.placement])

  useEffect(() => {
    const handle = () => {
      if (ref.current) {
        setOff(calcPlacement(ref.current))
      }
    }

    window.addEventListener("resize", handle)

    setTimeout(() => {
      handle()
    })

    return () => window.removeEventListener("resize", handle)
  }, [ref, step])

  return (
    <Modal
      footer={
        <Flex justify="space-between" style={{ width: "100%" }}>
          {backIsShown && (
            <Button onClick={() => actions.prev()} style={{ height: 32 }}>
              Back
            </Button>
          )}

          <Button
            onClick={() => actions.next()}
            style={{ height: 32, marginLeft: "auto" }}
          >
            Next
          </Button>
        </Flex>
      }
      maskClosable={false}
      maskStyle={{ zIndex: 999 }}
      onCancel={() => tour.onClose()}
      open={tour.isStarted}
      style={{
        ...placementCoords,
        position: "fixed",
        transform: "translate(0, 0)",
      }}
      styles={{
        content: { padding: 40 },
        wrapper: { zIndex: 9999999 },
      }}
      width={450}
    >
      <Flex
        ref={ref as LegacyRef<any>}
        style={{ position: "relative", zIndex: 9999999 }}
      >
        <OnboardingStepComponentWrap {...tour.activeStep!.popupProps()}>
          {step.component()}
        </OnboardingStepComponentWrap>
      </Flex>
    </Modal>
  )
})
